import { Routes } from '@angular/router';
import { MsalGuard } from '@azure/msal-angular';
import { CorrespondenceComponent } from './components/main/correspondence/correspondence.component';
import { EncounterBillingComponent } from './components/finance/encounter-billing/encounter-billing.component';
import { Campaign, CampaignStateActions, Diaries, DiaryManagerComponent, dispatchActionsGuard, EmailCampaignState, EligibilityLookupComponent, MedicalBillProcessorComponent, MedicalStateActions, ProviderManagerComponent, TemplateEmails } from '@harlowe/core';
import { EmailCampaignManagerComponent } from './components/main/email-campaign-manager/email-campaign-manager.component';

export const routes: Routes = 
[
    {
        path: '',
        redirectTo: 'Home',
        pathMatch: 'full',
    },
    {
        path: 'correspondence/:encounterId',
        component: CorrespondenceComponent,
        canActivate: [MsalGuard, dispatchActionsGuard],
        data: {
            actions: [TemplateEmails.LoadEmailTemplates]
        }
    },
    {
        path:'diarymanager',
        component: DiaryManagerComponent,
        canActivate: [MsalGuard, dispatchActionsGuard]
    },
    {
        path: 'finance/:encounterId',
        component: EncounterBillingComponent,
        canActivate: [MsalGuard]
    },
    {
        path:'medical-bill-processor',
        component: MedicalBillProcessorComponent,
        canActivate: [MsalGuard, dispatchActionsGuard],
        data: {
            actions: [MedicalStateActions.ProcessorLoaded]
        }
    },
    {
        path: 'providers',
        component: ProviderManagerComponent,
        canActivate: [MsalGuard]
    },
    {
        path: 'eligibility',
        component: EligibilityLookupComponent,
        canActivate: [MsalGuard]
    },
    {
        path: 'eligibility/:sourceId/:memberId',
        component: EligibilityLookupComponent,
        canActivate: [MsalGuard]
    },
    {
        path: 'email-campaign-manager',
        component: EmailCampaignManagerComponent,
        canActivate: [MsalGuard, dispatchActionsGuard],
        data: {
            actions: [CampaignStateActions.LoadCampaigns]
        }
    }
];


